import { render, staticRenderFns } from "./OfferView2.vue?vue&type=template&id=8c48d488&scoped=true"
import script from "./OfferView2.vue?vue&type=script&lang=js"
export * from "./OfferView2.vue?vue&type=script&lang=js"
import style0 from "./OfferView2.vue?vue&type=style&index=0&id=8c48d488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c48d488",
  null
  
)

export default component.exports